import { TableComment } from "../../TableComment";
import { DataHeader, DataSource, Layout, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFileImportProfile extends Layout {
    dataheaderFileImportProfile: DataHeader;
    layoutTableComment: TableComment;
    sourceComments: DataSource;
    sourceFileImportDetail: DataSource;
    sourceFileImportProfile: DataSource;
    switchActive: Switch;
    switchMatchOnPrevCode: Switch;
    tabComments: Tab;
    tabLayout: Tab;
    tableFileImportDetail: Table;
    tabsetDetails: Tabset;
    textboxActionType: Textbox;
    textboxDataType: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxStartRow: Textbox;
    textboxWorksheet: Textbox;
}
